import { defineMessages } from 'react-intl';

export const formatContextLinkingSessionDateMessages = defineMessages({
  today: {
    defaultMessage: 'Today',
    id: 'zWgbGgjUUg',
    description:
      'Label shown instead of a date when the session was created today',
  },
  yesterday: {
    defaultMessage: 'Yesterday',
    id: '6dIxDP1C8c',
    description:
      'Label shown instead of a date when the session was created yesterday',
  },
});
